import React from 'react'
import { Dropdown, Form, Header } from 'semantic-ui-react'
import { EEOOptions } from './EEOOptions'

export const DEFAULT_EEO = {
  gender: '',
  yearOfBirth: '',
  education: '',
  ethnicity: '',
  language: '',
  veteran_status: '',
  disability_status: '',
}

const EEO = ({ profile, setProfile }) => (
  <div id="eeo-section">
    <Header as="h4">
      U.S Equal Employment Opportunity Information (Completion is voluntary)
    </Header>
    {window.location.pathname === '/profile' && (
      <div className="content">
        We invite all individuals to voluntarily report their gender, year of
        birth, education, race/ethnicity, and primary language. We collect this
        information to help ensure the assessment is in compliance with
        non-discrimination laws and do not have an adverse impact on any
        particular race/ethnicity or gender. This information will remain
        confidential and will not be used for any purposes other than those
        stated above.
      </div>
    )}
    <br />
    <div className="content">
      <Form>
        <Form.Field>
          <label>What is your gender?</label>
          <Dropdown
            placeholder="Select your gender"
            fluid
            selection
            options={EEOOptions.gender}
            value={profile.gender}
            onChange={(e, { value }) =>
              setProfile({ ...profile, gender: value })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>What is your year of birth?</label>
          <Dropdown
            placeholder="Enter your year of birth"
            fluid
            selection
            search
            value={profile.yearOfBirth}
            options={EEOOptions.yearOfBirth}
            onChange={(e, { value }) =>
              setProfile({ ...profile, yearOfBirth: parseInt(value) })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>What is your educational achievement?</label>
          <Dropdown
            placeholder="Select your educational achievement"
            fluid
            selection
            options={EEOOptions.education}
            value={profile.education}
            onChange={(e, { value }) =>
              setProfile({ ...profile, education: value })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>What is your primary ethnicity?</label>
          <Dropdown
            placeholder="Select your ethnicity"
            fluid
            search
            selection
            options={EEOOptions.ethnicity}
            value={profile.ethnicity}
            onChange={(e, { value }) =>
              setProfile({ ...profile, ethnicity: value })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>What is your primary language?</label>
          <Dropdown
            placeholder="Select your language"
            fluid
            search
            selection
            options={EEOOptions.language}
            value={profile.language}
            onChange={(e, { value }) =>
              setProfile({ ...profile, language: value })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>What is your veteran status?</label>
          <Dropdown
            placeholder="Select a status"
            fluid
            selection
            options={EEOOptions.veteran_status}
            value={profile.veteran_status}
            onChange={(e, { value }) =>
              setProfile({ ...profile, veteran_status: value })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>What is your disability status?</label>
          <Dropdown
            placeholder="Select a status"
            fluid
            selection
            options={EEOOptions.disability_status}
            value={profile.disability_status}
            onChange={(e, { value }) =>
              setProfile({ ...profile, disability_status: value })
            }
          />
        </Form.Field>
      </Form>
    </div>
  </div>
)

export default EEO
